/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC721A, ERC721AInterface } from "../ERC721A";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "maxBatchSize_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextOwnerToExplicitlySet",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ERC721A__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    name_: string,
    symbol_: string,
    maxBatchSize_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721A> {
    return super.deploy(
      name_,
      symbol_,
      maxBatchSize_,
      overrides || {}
    ) as Promise<ERC721A>;
  }
  getDeployTransaction(
    name_: string,
    symbol_: string,
    maxBatchSize_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name_,
      symbol_,
      maxBatchSize_,
      overrides || {}
    );
  }
  attach(address: string): ERC721A {
    return super.attach(address) as ERC721A;
  }
  connect(signer: Signer): ERC721A__factory {
    return super.connect(signer) as ERC721A__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721AInterface {
    return new utils.Interface(_abi) as ERC721AInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721A {
    return new Contract(address, _abi, signerOrProvider) as ERC721A;
  }
}
